<template lang="pug">
  v-container
    div.d-flex.align-center
      div.text-md.font-semibold.primary--text {{ $t('performance') }}
      v-spacer
      v-menu(offset-y left max-height="200" allow-overflow)
        template(#activator="{ on }")
          v-btn.round-lg(color="primary" outlined height=32 v-on="on" small)
            v-icon(left) mdi-chevron-down
            .s2.text-capitalize {{ getEventName(selectedEvent) }}
        v-list.py-0(dense)
          v-list-item-group(v-model="selectedEvent" color="info500")
            v-list-item.px-6(:value="''")
              v-list-item-content
                v-list-item-title.text-sm.font-medium Overall
            template(v-for="event in eventList")
              v-list-item.px-6(:value="event.id" :keys="event.id")
                v-list-item-content
                  v-list-item-title.text-sm.font-medium {{ event.name }}

    v-row.mt-2
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('email_sent') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.total_sent }}
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('total_opens') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.total_open }}
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('open_rate') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.open_rate }}%
      v-col
        v-card.round-xl.box-border.pa-4(outlined)
          div.text-md.font-semibold.basic600--text {{ $t('unsubscribed') }}
          v-progress-circular.mt-4(v-if="isFetchingReport" :width="4" :size="40" color="primary400" indeterminate)
          div.heading-4.mt-4(v-else) {{ performance.unsubscribed }}
    
    v-row(align="center" v-if="!isMobileScreen")
      v-col(cols="12")
        .d-flex.align-center.justify-end
          yc-pagination-custom.ml-4.my-auto(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('item_list')" @input="pageChanged")
          slot(name="actions")

    .yc-table
      v-data-table.mt-sm-4.pb-16(:headers="headers" :items="events" :items-per-page="pageSize" :loading="isFetching" hide-default-footer disable-sort)
        template(v-slot:no-data)
          .mt-16
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        template(#item.success_rate="{ item }")
          div.text-end {{ item.success_rate }}%
        template(#item.created="{ item }")
          div.text-end {{ item.created | displayDate }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EmailBlastReport',
  components: {},
  props: ['group'],
  data () {
    return {
      isFetching: false,
      isFetchingReport: false,
      performance: {},
      selectedEvent: '',
      eventList: [],
      events: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      headers: [
        {
          text: this.$t('event'),
          value: 'name',
          enable: true,
          class: 'text-table-header'
        },
        {
          text: this.$t('success_rate'),
          value: 'success_rate',
          enable: true,
          class: 'text-table-header text-end'
        },
        {
          text: this.$t('sent_on'),
          value: 'created',
          enable: true,
          class: 'text-table-header text-end'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize () {
      this.fetchBlastEvents(1)
    },
    selectedEvent (val) {
      this.fetchBlastReport(val)
    }
  },
  created () {
    this.fetchBlastEvents(1)
    this.fetchBlastReport()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchBlastEvents(page) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        method: 'email',
        group: this.group,
      }
      this.$axios.get(`/connect/${this.company.slug}/blast_events`, { params })
        .then(resp => {
          if (resp.data.results) {
            this.events = resp.data.results
          }
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchBlastReport(event) {
      this.isFetchingReport = true
      const params = {
        method: 'email',
        event: event || ''
      }
      this.$axios.get(`/connect/${this.company.slug}/groups/${this.group}/blast_report`, { params })
        .then(resp => {
          if (resp.data.email) {
            this.performance = resp.data.email
            this.eventList = this.performance.events
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingReport = false
        })
    },
    pageChanged(num) {
      this.fetchBlastEvents(num)
    },
    getEventName (id) {
      let event = this.eventList.find(f => f.id === id)
      if (event) {
        return event.name
      }
      return 'Overall'
    }
  }
}
</script>

<style scoped>
.box-border {
  border: var(--v-basic500) solid 1px;
}
</style>